var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('addOrganization',{attrs:{"organization":_vm.organization}})}
var staticRenderFns = []

export { render, staticRenderFns }